export const areArraysEqual = (arrA: any, arrB: any) => {
  if (arrA === arrB) return true;
  if (nullOrUndefined(arrA) || nullOrUndefined(arrB)) return false;

  const isLengthEqual = arrA.length === arrB.length;
  if (!isLengthEqual) return false;

  for (let i = 0; i < arrA.length; i++) {
    if (arrA[i] !== arrB[i]) {
      return false;
    }
  }

  return true;
};

const nullOrUndefined = (obj: any) => obj === null || obj === undefined;
